import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { BlogList, BlogCard, BlogHero } from '@grandvisionhq/content';
import { useIntl } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import { useBloomreachArticles } from '../../hooks/use-bloomreach-articles.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsBlogOverviewItem = ({ content  })=>{
    const { locale , getLabel  } = useIntl();
    const { title , coverImage , readingTime , publishDate , summary , url  } = content;
    const [link] = useBloomreachLinks([
        {
            url: url !== null && url !== void 0 ? url : '#'
        }
    ]);
    const image = parseBloomreachImage(coverImage);
    return /*#__PURE__*/ React.createElement(BlogCard, {
        url: link.url,
        title: title,
        summary: summary,
        readingTime: readingTime,
        publishDate: publishDate,
        image: image === null || image === void 0 ? void 0 : image.original,
        mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
        locale: locale,
        minutesLabel: getLabel('blog.minutesToRead')
    });
};
const CmsBlogHero = ({ content  })=>{
    const { getLabel  } = useIntl();
    const { coverImage , title , url , summary  } = content;
    const [link] = useBloomreachLinks([
        {
            url: url !== null && url !== void 0 ? url : '#'
        }
    ]);
    const image = parseBloomreachImage(coverImage);
    if (!content || !image) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(BlogHero, {
        title: title,
        link: link.url,
        summary: summary,
        image: image.original,
        mobileImage: image.mobile,
        readMoreLabel: getLabel('blog.readArticle')
    });
};
const CmsBlogOverview = ({ component , page  })=>{
    const { getLabel  } = useIntl();
    const { title ='Blog'  } = component.getParameters();
    const { loading , error , result , loadNextPage  } = useBloomreachArticles({
        component,
        page
    });
    if (error) {
        console.error('CmsBlogOverview: Failed to fetch more articles from Bloomreach.', error);
    }
    const { highlighted , paged  } = result;
    const { currentPage , nextPage , totalPages  } = paged;
    const hasMoreItems = nextPage !== null && nextPage !== currentPage && nextPage <= totalPages;
    if (!paged.items) {
        console.error('CmsBlogOverview: No blog items found to render.');
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, highlighted && /*#__PURE__*/ React.createElement(CmsBlogHero, {
        content: highlighted
    }), /*#__PURE__*/ React.createElement(BlogList, {
        title: title,
        noArticlesLabel: getLabel('blog.noArticles')
    }, paged.items.map((item)=>item && /*#__PURE__*/ React.createElement(CmsBlogOverviewItem, {
            key: item.id,
            content: item
        })
    )), hasMoreItems && /*#__PURE__*/ React.createElement("div", {
        className: "blog-list__show-more"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "blog-list__button",
        variant: "outline",
        color: "primary",
        isLoading: loading,
        href: `?page=${result.paged.nextPage}`,
        onClick: (e)=>{
            e.preventDefault();
            loadNextPage();
            if (result.paged.nextPage) {
                const url = new URL(window.location.href);
                url.searchParams.set('page', result.paged.nextPage.toString());
                window.history.pushState({}, '', url);
            }
        },
        caption: getLabel('blog.articles.showMore')
    })));
};
var BlogOverview = compose(withBreakpointVisibility, withAnchor)(CmsBlogOverview);

export { CmsBlogHero, CmsBlogOverview, CmsBlogOverviewItem, BlogOverview as default };
//# sourceMappingURL=BlogOverview.js.map
